import React from "react";

interface SiteCardProps {
  name: string;
  /** e.g. "Domain property" — what this site covers, in the provider's vocabulary. */
  kind: string;
  /** Optional chip such as the GSC permission level; omitted when there is none. */
  badge?: string;
  onConnect: () => void;
  isConnected: boolean;
  isSaving: boolean;
}

const SiteCard: React.FC<SiteCardProps> = ({
  name,
  kind,
  badge,
  onConnect,
  isConnected,
  isSaving,
}) => (
  <div className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col hover:border-brand-primary transition-colors shadow-sm">
    <div className="mb-4">
      <h3 className="text-base font-semibold text-gray-900 break-all">{name}</h3>
      <p className="text-sm text-gray-600 mt-0.5">{kind}</p>
      {badge && (
        <div className="flex flex-wrap gap-2 mt-1">
          <span className="text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 bg-green-100 text-green-800 rounded">
            {badge}
          </span>
        </div>
      )}
    </div>
    <div className="mt-auto">
      {isConnected ? (
        <p className="text-sm font-medium text-green-700 py-2">Connected</p>
      ) : (
        <button
          type="button"
          onClick={onConnect}
          disabled={isSaving}
          className="w-full py-2 text-xs text-white bg-brand-primary rounded-lg font-semibold hover:bg-brand-primary-hover disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm"
        >
          {isSaving ? (
            <span className="flex items-center justify-center gap-1">
              <span className="animate-spin inline-block w-3 h-3 border-2 border-white border-t-transparent rounded-full" />
              Connecting...
            </span>
          ) : (
            "Connect"
          )}
        </button>
      )}
    </div>
  </div>
);

export default SiteCard;
